export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7682.385fb206.jpg";